import { useTranslation } from 'react-i18next';

export const PersonalBestDisplay = ({personalBest}) => {
    const { t } = useTranslation();
    if (!personalBest) return null;
    
    return (
      <div className="bg-white px-4 sm:py-3 py-2 rounded-lg shadow-sm mb-4">
        <h4 className="font-semibold mb-4 border-b border-stone-200">{t('game.welcome.personalBest')}</h4>
        <div className="grid grid-cols-2 gap-4 pb-2">
          <div>
            <div className="text-2xl font-semibold">{personalBest.daysSurvived}</div>
            <div className="text-sm text-stone-500">{t('game.welcome.daysSurvived')}</div>
          </div>
          <div>
            <div className="text-2xl font-semibold">{t('game.currency', {amount: personalBest.moneyEarned})}</div>
            <div className="text-sm text-stone-500">{t('game.welcome.moneyEarned')}</div>
          </div>
        </div>
      </div>
    );
  };